class CustomCheckoutButton {
  constructor() {
    this.init()
  }

  init() {
    document.addEventListener("click", (e) => {
      if (e.target.closest("[data-custom-checkout-button]")) {
        let quantity = 1;

        const target = e.target.closest("[data-custom-checkout-button]")
        const itemId = target.getAttribute("data-custom-variant-id");
        const form = target.closest("form");
        const qtyInput = form.querySelector("input[name='quantity']");

        if (qtyInput) {
          quantity = qtyInput.value;
        }

        this.ajaxAddToCart(itemId, quantity, target);
      }
    })
  }

  ajaxAddToCart(itemId, qty, button) {
    button.classList.add("disabled");
    button.disabled = true;

    let formData = {
      'items': [{
       'id': +itemId,
       'quantity': +qty
       }]
     };

    fetch(window.theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (response.ok) {
        document.location.pathname = "/checkout";
      }
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      button.classList.remove("disabled");
      button.disabled = false;
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new CustomCheckoutButton();
})

class CardPagination extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const container = this.closest(".grid-product__image-mask");
    if (!container) return;
    const scrolledContainer = container.querySelector(".image-wrap--slider");
    const imageSlides = scrolledContainer.querySelectorAll("image-element");
    if(!scrolledContainer && imageSlides.length <= 1) return;

    this.createDots(imageSlides.length);

    scrolledContainer.addEventListener("scroll", (e) => {
      const activePositionIndex = Math.floor(scrolledContainer.scrollLeft / imageSlides[0].offsetWidth);
      this.setActive(activePositionIndex)
    });
  }

  setActive(activeIndex) {
    const items = this.querySelectorAll(".card-pagination-item");
    [...items].map(item => item.classList.remove("active"));
    items[activeIndex].classList.add("active");
  }

  createDots(imageCount) {
    for(let i = 0; i < imageCount; i++) {
      const dotEl = document.createElement("span");
      dotEl.className = "card-pagination-item";
      if (i === 0) {
        dotEl.classList.add("active");
      }
      this.appendChild(dotEl);
    }
  }
}

customElements.define("card-pagination", CardPagination);